const CLOSED_FILE_VIEWER = 'Closed file wiewer',
    CLICKED_DOWNLOAD_FILES = 'Clicked download file',
    CLICKED_PLAYER_CONTROLS = 'Clicked player controls',
    CLICKED_COLLABORATION_TOGGLE_PANEL = 'Clicked collaboration toggle panel',
    START_NEW_COMMENT = 'Started new collaboration comment',
    CLICKED_TIMESTAMP_TOGGLE = 'Clicked collaboration toggle timestamp',
    SAVE_NEW_COMMENT = 'Saved collaboration comment',
    CANCEL_NEW_COMMENT = 'Cancelled collaboration comment',
    EDIT_OR_DELETE_COMMENT = 'Managed collaboration comment',
    SELECT_COMMENT = 'Opened collaboration comment',
    SUBMIT_COMMENTS = 'Submitted collaboration comments',
    CLICKED_WARNING_MODAL = 'Clicked collaboration warning modal',
    START_NEW_REPLY = 'Started collaboration comment reply',
    SAVE_NEW_REPLY = 'Saved collaboration comment reply',
    OPENED_FILE_VIEWER = 'Opened file viewer',
    CLICKED_INVITE_BUTTON = 'Clicked invite button',
    DISMISS_INVITE_MODAL = 'Clicked close invite window',
    ENTER_EMAIL = 'Entered email address',
    INVITE = 'Clicked send collaboration invitation',
    OPEN_FULLNAME_MODAL = 'Opened collaboration full name modal',
    SUBMIT_FULLNAME = 'Submitted collaboration full name',
    DISMISS_FULLNAME = 'Closed collaboration full name modal',
    OPEN_COLLABORATOR_LIST = 'Opened collaborators list',
    CLOSE_COLLABORATOR_LIST = 'Closed collaborators list',
    CLICKED_RESEND_COLLABORATOR = 'Clicked resend collaboration invitation',
    CLICKED_REMOVE_COLLABORATOR = 'Clicked remove collaborator',
    SEEN_INVITE_BUTTON = 'Seen Invite button',
    OPENED_SETTING_MODAL = 'Opened collaboration settings modal',
    NAVIGATION_BETWEEN_FILES = 'Navigated between files',
    COPIED_SHAREABLE_LINK = 'Copied Shareable Link in Collaboration',
    VIEWED_COLLABORATION = 'Viewed Collaboration Tool';

export {
    CLOSED_FILE_VIEWER,
    CLICKED_DOWNLOAD_FILES,
    CLICKED_PLAYER_CONTROLS,
    CLICKED_COLLABORATION_TOGGLE_PANEL,
    START_NEW_COMMENT,
    CLICKED_TIMESTAMP_TOGGLE,
    SAVE_NEW_COMMENT,
    CANCEL_NEW_COMMENT,
    EDIT_OR_DELETE_COMMENT,
    SELECT_COMMENT,
    SUBMIT_COMMENTS,
    CLICKED_WARNING_MODAL,
    START_NEW_REPLY,
    SAVE_NEW_REPLY,
    OPENED_FILE_VIEWER,
    CLICKED_INVITE_BUTTON,
    DISMISS_INVITE_MODAL,
    ENTER_EMAIL,
    INVITE,
    OPEN_FULLNAME_MODAL,
    SUBMIT_FULLNAME,
    DISMISS_FULLNAME,
    OPEN_COLLABORATOR_LIST,
    CLOSE_COLLABORATOR_LIST,
    CLICKED_RESEND_COLLABORATOR,
    CLICKED_REMOVE_COLLABORATOR,
    SEEN_INVITE_BUTTON,
    OPENED_SETTING_MODAL,
    NAVIGATION_BETWEEN_FILES,
    COPIED_SHAREABLE_LINK,
    VIEWED_COLLABORATION
};
